export default __webpack_public_path__ + "static/media/Blade's Leggings of the Hidden Tomb.8ce511dd.jpg";